import Check from "assets/icons/jobs/Check";
import Download from "assets/icons/jobs/Download";
import Warning from "assets/icons/jobs/Warning";
import WorkInProgress from "assets/icons/jobs/Work-in-progress";
import WorkInProgress2 from "assets/icons/jobs/Work-in-progress2";

  export const JobStatusIcons = {
    IN_QUEUE: <WorkInProgress2 />,
    SUCCESS: <Check />,
    FAILED: <Warning />,
    IN_PROGRESS: <WorkInProgress />,
    EXCEL: <Download />,
  };

